/** Pure helpers for column ordering & visibility — extracted from Table.tsx
 * to keep that file under the 400-line cap. */
import type { Column } from "../Table";

// Storage key used to persist actions visibility in `hiddenKeys`. The
// actions slot is not a column in the array sense, but it shares the
// hide/show machinery with data columns so users can toggle it from the
// configurable popover.
export const ACTIONS_COLUMN_KEY = "__actions__";

/** Apply user column order + hidden keys to data columns. Actions visibility
 * is tracked separately (see ACTIONS_COLUMN_KEY) and rendered as a slot,
 * not a column. */
export function buildVisibleColumns<T>(
  columns: Column<T>[],
  columnOrder: string[],
  hiddenKeys: Set<string>,
): Column<T>[] {
  const colMap = new Map(columns.map((c) => [c.key, c]));
  const ordered: Column<T>[] = [];
  for (const key of columnOrder) {
    const col = colMap.get(key);
    if (col && !hiddenKeys.has(key)) ordered.push(col);
  }
  for (const col of columns) {
    if (!columnOrder.includes(col.key) && !hiddenKeys.has(col.key)) {
      ordered.push(col);
    }
  }
  return ordered;
}
